// Header
$('body.index header.header .header__icon.header__icon--cart').click( function() {
    $('header-drawer .menu-drawer-container').removeClass('menu-opening');
    $('header-drawer .menu-drawer-container summary').attr('aria-expanded', 'false');
    $('header-drawer .menu-drawer-container').removeAttr('open');
})

// FAQs
$('.faq_title').click( function() {
    $(this).parent().siblings().find('.faq_details').slideUp();
    $(this).parent().siblings().removeClass('active');
    $(this).parent().toggleClass('active');
    $(this).next().slideToggle();
})

// 
var coll_mincount = 0,
    coll_maxcount = 60,
    col_isLoading = false,
    totalProducts = $(".collection .product-grid li").length; // Get total products count

$(".collection .product-grid li").slice(coll_maxcount).hide();

function updateLoaderProgress() {
    let loadedProducts = $(".collection .product-grid li:visible").length;
    let progress = (loadedProducts / totalProducts) * 100;
    $(".progress-circle").css("stroke-dasharray", progress + ", 100"); // Adjust SVG progress
}

function showLoader_col() {
    $(".collection_product_list .loader").show();
    $(".collection_list_sec .collection .loader").css({ opacity: "1", visibility: "visible" });
}

function hideLoader_col() {
    $(".collection_list_sec .collection .loader").hide();
}

function hideLoader1() {
    $(".collection_list_sec  .collection .loader").css({ opacity: "0", visibility: "hidden", display: 'none' });
}

$(window).scroll(function () {
    if ($(window).scrollTop() + $(window).height() >= $(document).height() - 350 && !col_isLoading) {
        col_isLoading = true;
        showLoader_col();

        setTimeout(function () {
            $(".collection .product-grid li").slice(coll_mincount, coll_maxcount).slideDown(450);
            coll_mincount = coll_maxcount;
            coll_maxcount += 40;
            col_isLoading = false;
            updateLoaderProgress(); // Update progress after loading
            // hideLoader1();
        }, 450);

        if ($(".collection .product-grid li:hidden").length == 0) {
            hideLoader1();
        }
    }
});

// Append Loader with Progress Indicator
$(".collection_list_sec .collection").append(`
    <li class="loader">
        <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="19" cy="19" r="16" stroke="#1E1E1E" stroke-width="3" fill="none" opacity="0.2"/>
            <circle cx="19" cy="19" r="16" stroke="#1E1E1E" stroke-width="3" fill="none"
                stroke-dasharray="0, 100" class="progress-circle" stroke-linecap="round"/>
        </svg>
        <span>Loading...</span>
    </li>
`);

// Initialize progress indicator
updateLoaderProgress();


// 

$(document).ready(function () {
    let currentUrl = window.location.pathname;
    $(".collection_list_items li ").each(function () {
        if ($(this).find('a').attr("href") === currentUrl) {
            $(this).addClass("active");
        }
    });


if ($(window).width() <= 767){
  $('.product__media-list').removeClass('slider');
  new Swiper('.swiper-container', {
     loop: false,
     slidesPerView: 1,
     paginationClickable: true,
     spaceBetween: 0,
     autoHeight: true,
     pagination: {
       el: ".swiper-pagination",
       type: "progressbar"
    }
  });
}
});



// Product page product image model
$(document).ready(function () {
  var pro_slick_slider = $('.main-product-image-modal');
  pro_slick_slider.slick({
    dots: false,
    arrows: true,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 500,
    fade: true,
    adaptiveHeight: false,
    cssEase: 'linear',
    prevArrow:'<button class="slick-prev slick-arrow"><svg width="18" height="34" viewBox="0 0 18 34" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17 1L1 17L17 33" stroke="black"/></svg></button>',
    nextArrow:'<button class="slick-next slick-arrow"><svg width="18" height="34" viewBox="0 0 18 34" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L17 17L1 33" stroke="black"/></svg></button>'
  });
  $('.product__media-wrapper ul.product__media-list li .product__media img').click( function() {
    var clicked_image_url = $(this).attr('src');
    console.log(clicked_image_url,"Image Click");

    $('.click-model-image img').attr('src' ,clicked_image_url);
    $('.main-product-image-modal-wrapper').addClass('active-model');
    $('body').addClass('overflow-hidden');
    pro_slick_slider.slick('refresh');
      // setTimeout(function() {
        var slider_height = $('.main-product-image-modal').height();
        console.log(slider_height);
        $('.main-product-image-modal li').css('height', slider_height);
      // }, 500);
  });
  $('.close-icon-wrapper').click( function() {
    $('.main-product-image-modal-wrapper').removeClass('active-model');
    $('body').removeClass('overflow-hidden');
  });
});


// $(document).ready(function(){
  
// });
$(window).on('resize', function() {
  var slider_height = $('.main-product-image-modal').height();
  console.log(slider_height);
  $('.main-product-image-modal li').css('height', slider_height);
});
